const selectColorCoupon: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#8B1831",
    buttonColor: "#61112F",
  },
  {
    color: "#2992DD",
    buttonColor: "#541C5F",
  },
  {
    color: "#FFAE00",
    buttonColor: "#3E00B3",
  },
  {
    color: "#479494",
    buttonColor: "#000000",
  },
  {
    color: "#7D66D9",
    buttonColor: "#4953B4",
  },
  {
    color: "#AE4824",
    buttonColor: "#C1692F",
  },
];

export default selectColorCoupon;
